module.exports = __webpack_public_path__ + "static/logo-97c9f25fd21bff06ccb87863da1aa9ec.png";